import * as actions from '../ActionType/UserActionType';
import CustomerHelperServices  from '../Reducers/CustomerResponseHelper';
const dispatchAction:any=(dispatch:any ,actionType:any, data:any,  error:string, message:string)=>{
    dispatch({type:actionType,payload:data, message:message});
};

class CustomerServicesApi {
    customers = (accessToken:any) =>async (dispatch:any )=> {
       try{
        const customer = await CustomerHelperServices.CUSTOMERS(accessToken);
        if(customer){
            dispatchAction(dispatch, actions.CUSTOMER_ALL, customer)
        }else{
            dispatchAction(dispatch,actions.CUSTOMER_ALL, customer, [], 'Invalid customer !')
        }
       }catch(error){console.log('customers error  ==>',error)}
    };
    AddClientAdmin = (client:any,invitation:any, accessToken:string,enqueueSnackbar:any) =>async (dispatch:any )=>  {
        try{
            const addClient = await CustomerHelperServices.ADD_CUSTOMER(client,accessToken);
            if(addClient){
                addClient?.error?
                enqueueSnackbar(addClient?.error?.message, { variant: 'error' }):
                dispatchAction(dispatch, actions.CUSTOMER_CREATE, addClient)
                if(invitation != undefined && !addClient?.error ){
                    invitation.customerId = addClient.id;
                    dispatch(this.sendClientAdminInvitation(invitation,accessToken,enqueueSnackbar));
                }
                // (enqueueSnackbar('Success!', { variant: 'success' }));
                !addClient.error&&enqueueSnackbar('Success!', { variant: 'success' })
                
            }else{
                dispatchAction(dispatch,actions.CUSTOMER_CREATE, addClient, [], 'Invalid add Client  !')
                
            }
        }catch(err:any){console.log(' Add Client error  ==>',err)}
    };
    getCustomerById = (customerId:any,accessToken:string) =>async (dispatch:any )=>  {
        try{
            const getCutomer = await CustomerHelperServices.GET_CUSTOMER(customerId,accessToken);
            if( getCutomer){
                dispatchAction(dispatch, actions.CUSTOMER_GET, getCutomer)
            }else{
                dispatchAction(dispatch,actions.CUSTOMER_GET, getCutomer, [], 'Invalid  get Cutomer  !')
            }
        }catch(error){console.log('  Client error  ==>',error)}
    };
    DeleteClient = (email:any,accessToken:any,enqueueSnackbar:any) =>async (dispatch:any )=>  {
        try{
            const deleteClient = await CustomerHelperServices.DELETE_CUTOMER(email,accessToken);
            if(deleteClient){
                deleteClient?.error?
                enqueueSnackbar(deleteClient?.error?.message, { variant: 'error' }):
                dispatchAction(dispatch, actions.CUSTOMER_DELETE, deleteClient)
                (enqueueSnackbar('Success!', { variant: 'success' }));
            }else{
                dispatchAction(dispatch,actions.CUSTOMER_DELETE, deleteClient, [], 'Invalid delete Client  !')
            }
        }catch(error){console.log(' delete Client error  ==>',error)}
    }
    sendClientAdminInvitation = (param:any, accessToken:string,enqueueSnackbar:any)=>async (dispatch:any )=> {
        try{
            const sendClient = await CustomerHelperServices.SENT_INVITATION_CUSTOMER(param,accessToken);
            if(sendClient){
                dispatchAction(dispatch, actions.CUSTOMER_INVITATION, sendClient)
            }else{
                dispatchAction(dispatch,actions.CUSTOMER_INVITATION, sendClient, [], 'Invalid send invitation  !')
            }
        }catch(error){console.log(' send invitation error  ==>',error)}
    }
    uploadFile = (param:any,customerId:any,accessToken:string,notifySuccess:any,enqueueSnackbar:any)=>async (dispatch:any )=> {
        try{
            const uploadDocument = await CustomerHelperServices.UPLOAD_FILE(param,customerId,accessToken);
            if( uploadDocument?.name){
                let fileUploaded:any ="fileUploaded";
                notifySuccess(uploadDocument?.name,fileUploaded)
                dispatchAction(dispatch, actions.DOCUMENT_UPLOAD, uploadDocument)
            }else{
                enqueueSnackbar(uploadDocument?.error?.message, { variant:'error'})
                dispatchAction(dispatch,actions.DOCUMENT_UPLOAD, uploadDocument, [], 'Invalid upload file  !')
            }
        }catch(error){console.log(' upload document error  ==>',error)}
    }
    documentUpdateFile = (param:any,documentId:any,accessToken:string,enqueueSnackbar:any)=>async (dispatch:any )=> {
        try{
            const updateDocument = await CustomerHelperServices.DOCUMENT_UPDATE_FILE (param,documentId,accessToken);
            if( updateDocument){
                enqueueSnackbar('Success!', { variant: 'success' });
                dispatchAction(dispatch, actions.DOCUMENT_FILE_UPDATE, updateDocument)
            }else{
                dispatchAction(dispatch,actions.DOCUMENT_FILE_UPDATE, updateDocument, [], 'Invalid update document  !')
                enqueueSnackbar(updateDocument?.error?.message, { variant: 'error' });
            }
        }catch(error){console.log(' update document error  ==>',error)}
    }
    deleteDocumentFile = (documentId:any,accessToken:string,enqueueSnackbar:any)=>async (dispatch:any )=> {
        console.log(documentId,"documentid")
        try{
            const deleteDocument = await CustomerHelperServices.DELETE_DOCUMENT (documentId,accessToken);
            if( deleteDocument){
                deleteDocument?.error?
                enqueueSnackbar(deleteDocument?.error?.message, { variant: 'error' }):
                dispatchAction(dispatch, actions.DOCUMENT_DELETE, deleteDocument)
                (enqueueSnackbar('Success!', { variant: 'success' }))
            }else{
                dispatchAction(dispatch,actions.DOCUMENT_DELETE, deleteDocument, [], 'Invalid delete document  !')
            }
        }catch(error){console.log('delete document error  ==>',error)}
    }
    updateInfoCustomer = (param:any,customerId:any,accessToken:string,enqueueSnackbar:any)=>async (dispatch:any )=> {
        try{
            const upadteInfomation = await CustomerHelperServices.INFO_UPDATE_CUSTOMER(param,customerId,accessToken);
            if( upadteInfomation){
                upadteInfomation?.error?
                enqueueSnackbar(upadteInfomation?.error?.message, { variant: 'error' }):
                dispatchAction(dispatch, actions.CUSTOMER_INFO_UPDATE, upadteInfomation)
                (enqueueSnackbar('Success!', { variant: 'success' }));
            }else{
                dispatchAction(dispatch,actions.CUSTOMER_INFO_UPDATE, upadteInfomation, [], 'Invalid send Client  !')
            }
        }catch(error){console.log('customer info error  ==>',error)}
    }
    changeCustomerStatus = (customerId:any,accessToken:string,enqueueSnackbar)=>async (dispatch:any )=> {
        try{
            const statusCustomer = await CustomerHelperServices.CHANGE_CUSTOMER_STATUS(customerId,accessToken);
            if( statusCustomer){
                statusCustomer?.error?
                enqueueSnackbar(statusCustomer?.error?.message, { variant: 'error' }):
                dispatchAction(dispatch, actions.CUSTOMER, statusCustomer)
                (enqueueSnackbar('Success!', { variant: 'success' }));
            }else{
                dispatchAction(dispatch,actions.CUSTOMER, statusCustomer, [], 'Invalid send Client  !')
            }
        }catch(error){console.log('customer info error  ==>',error)}
    }
getAllDocuments = (customerId : number,userId:any,accessToken:string,isArchive:any)=>async (dispatch:any )=> {
        try{
            const allDocuments = await CustomerHelperServices.ALL_DOCUMENT(customerId,userId, accessToken,isArchive);
            if( allDocuments){
                dispatchAction(dispatch, actions.ALL_DOCUMENT, allDocuments)
            }else{
                dispatchAction(dispatch,actions.ALL_DOCUMENT, allDocuments, [], 'Invalid all documents  !')
            }
        }catch(error){console.log('all documents actions files  ==>',error)}
    }

downloadFile=(documentId:any,accessToken:any,notifySuccess:any,ErrorMessage:any)=>async (dispatch:any) => {
    try {
        const download = await CustomerHelperServices.DOWNLOAD_DOCUMENT(documentId,accessToken);
        if( download?.size>=0){
            let downloaded:any = 'download' 
            notifySuccess(download,downloaded)
            dispatchAction(dispatch, actions.DOWNLOAD_DOCUMENT, download)
        }else{
            let notFound:any = 'getUserGroup';
            ErrorMessage(download,notFound)
            dispatchAction(dispatch,actions.DOWNLOAD_DOCUMENT, download, [], 'Invalid download  !')
        }
    } catch (error) {
        console.log('download file actions files  ==>',error)
    } 
}
clientAdminCutomerDelete=(documentId:any,userId:any,accessToken:any,enqueueSnackbar:any)=>async (dispatch:any) => {
    try {
        const deleted = await CustomerHelperServices.DELETE_USER_CLIENT(documentId,userId,accessToken);
        if( deleted){
            deleted?.error?
            enqueueSnackbar(deleted?.error?.message, { variant: 'error' }):
            dispatchAction(dispatch, actions.CLIENT_ADMIN_CUSTOMER, deleted)
            (enqueueSnackbar('Success!', { variant: 'success' }));
        }else{
            dispatchAction(dispatch,actions.CLIENT_ADMIN_CUSTOMER, deleted, [], 'Invalid delete client Admin  !')
        }
    } catch (error) {
        console.log('delete client customer actions files  ==>',error)
    } 
}
getUsersPermission=(endPoint:any,documentId:any,accessToken:any,enqueueSnackbar:any)=>async (dispatch:any) => {
    try {
        const getPermission = await CustomerHelperServices.USERS_PERMISSIONS(endPoint,documentId,accessToken);
        if( getPermission){
            getPermission?.error?
            enqueueSnackbar(getPermission?.error?.message, { variant: 'error' }):
            dispatchAction(dispatch, actions.PERMISSION_USER, getPermission);
        }else{
            dispatchAction(dispatch,actions.PERMISSION_USER, getPermission, [], 'Invalid user permission  !')
        }
    } catch (error) {
        console.log('user permission document actions files  ==>',error)
    } 
}
getUsersGroupPermission=( endPoint:any,documentId:any,accessToken:any)=>async (dispatch:any) => {
    try {
        const getGroupPermission = await CustomerHelperServices.USER_GROUPS_PERMISSIONS(endPoint,documentId,accessToken);
        if( getGroupPermission){
            dispatchAction(dispatch, actions.GROUP_USER_PERMISSION, getGroupPermission)
        }else{
            dispatchAction(dispatch,actions.GROUP_USER_PERMISSION, getGroupPermission, [], 'Invalid user group permission  !')
        }
    } catch (error) {
        console.log('user group permission document actions files  ==>',error)
    } 
}
deleteHardPermissionUser = (userId:any,accessToken:string,enqueueSnackbar:any)=>async (dispatch:any) => {
    try {
        const hard_delete_User = await CustomerHelperServices.HARD_DELETE_PERMISSION(userId,accessToken);
        if (hard_delete_User) {
            if(hard_delete_User?.error){
                enqueueSnackbar(hard_delete_User?.error?.type, { variant: 'error' })
            }else{
                console.log(hard_delete_User,'hard_delete_User')
                enqueueSnackbar('Success!', { variant: 'success' })
                dispatchAction(dispatch,actions.DELETE_HARD,hard_delete_User)
            }
        }else{
            dispatchAction(dispatch,actions.DELETE_HARD,hard_delete_User,"Invalid hard delete ")  
        }
    } catch (error) {
        console.log("user permission is deleted",error);
    }
    
}
}
export default new CustomerServicesApi();